import { CountryCode, Gender } from "Infrastructure/Api/Api";
import { getAddressValidationSchema } from "Schemas/addressSchemas";
import type { TFunction } from "Translations/Resources";
import { z } from "zod";

export const getBeneficialOwnerSchema = (t: TFunction) =>
  z.object({
    publicID: z.string().nullish(),
    firstName: z.string().nullable(),
    lastName: z.string().nullable(),
    birthDate: z.string().nullish(),
    gender: z.enum(Gender),
    address: getAddressValidationSchema(t),
    nationality: z.enum(CountryCode).nullable(),
    isForeigner: z.boolean().default(false),
  });

export type BeneficialOwnerFormSchemaInput = z.input<
  ReturnType<typeof getBeneficialOwnerSchema>
>;
export type BeneficialOwnerFormData = z.infer<
  ReturnType<typeof getBeneficialOwnerSchema>
>;
